import { combineReducers } from "redux";

import Ticket from "./Ticket";
import Dimension from "./Dimension";
import Misc from "./Misc";

export default combineReducers(
    Object.assign(
        {},
        {},
        {
            Ticket,
            Dimension,
            Misc
        }
    )
);
